// 9fbef606107a605d69c0edbcd8029e5d
import { ACCESSORIES_REDUCER_PATTERN } from '../../../../../constants/reducer.constants';
import theme from '../../../../../../styles/themes/TCP';

export const SET_ACCESSORIES_LOADING_STATE = `${ACCESSORIES_REDUCER_PATTERN}ACCESSORIES_REDUCER_PATTERN`;

export const ACCESSORIES_CONSTANTS = {
  FETCH_ACCESSORIES_FROM_IDS: 'FETCH_ACCESSORIES_FROM_IDS',
  FETCH_SECONDARY_ACCESSORIES_FROM_IDS: 'FETCH_SECONDARY_ACCESSORIES_FROM_IDS',
  ACCESSORIES_LOADER: 'ACCESSORIES_LOADER',
  SECONDARY_ACCESSORIES_LOADER: 'SECONDARY_ACCESSORIES_LOADER',
  SET_ACCESSORIES: 'SET_ACCESSORIES',
  SET_CLICKED_ACCESSORY: 'SET_CLICKED_ACCESSORY',
  GET_SELECTED_ACCESSORIES: 'GET_SELECTED_ACCESSORIES',
  REMOVE_CLICKED_ACCESSORY: 'REMOVE_CLICKED_ACCESSORY',
  REPLACE_ACCESSORY: 'REPLACE_ACCESSORY',
  CLEAR_SELECTED_ACCESSORIES: 'CLEAR_SELECTED_ACCESSORIES',
  REPLACE_SECONDARY_ACCESSORY: 'REPLACE_SECONDARY_ACCESSORY',
  AUTO_INCREMENT_ACCESSORY: 'AUTO_INCREMENT_ACCESSORY',
  PARENT_PRODUCT_QTY_CHNG: 'PARENT_PRODUCT_QTY_CHNG',
  SET_PARENT_ACC: 'SET_PARENT_ACC',
  SET_PARENT_CUSTOMIZATION_TYPE: 'SET_PARENT_CUSTOMIZATION_TYPE',
  SET_UPDATE_TYPE: 'SET_UPDATE_TYPE',
  SET_SHOW_0007_ERROR: 'SET_SHOW_0007_ERROR',
  SET_ALLOW_MULTIPLE_SELECT: 'SET_ALLOW_MULTIPLE_SELECT',
  SET_SECONDARY_ACCESSORIES: 'SET_SECONDARY_ACCESSORIES',
  SET_SECONDARY_CLICKED_ACCESSORY: 'SET_SECONDARY_CLICKED_ACCESSORY',
  SET_CURRENT_HIGHLIGHTED_INDEX: 'SET_CURRENT_HIGHLIGHTED_INDEX',
  FETCH_PRODUCTDETAIL_BY_ID: 'FETCH_PRODUCTDETAIL_BY_ID',
  SET_SECONDARY_ACCESSORY_DETAIL: 'SET_SECONDARY_ACCESSORY_DETAIL',
  REMOVE_SECONDARY_ACCESSORY: 'REMOVE_SECONDARY_ACCESSORY',
  RESET_SECONDARY_ACCESSORY_DETAIL: 'RESET_SECONDARY_ACCESSORY_DETAIL',
  REMOVE_SECONDARY_ACCESSORY_WRT_PARENT_ID: 'REMOVE_SECONDARY_ACCESSORY_WRT_PARENT_ID',
  SET_TEMPORARY_SECONDARY_SELECTED_ACCESSORIES: 'SET_TEMPORARY_SECONDARY_SELECTED_ACCESSORIES',
  GRAND_PARENT_ID: 'GRAND_PARENT_ID',
  REMOVE_SELECTED_TEMPORARY_SECONDARY_ACCESSORIES:
    'REMOVE_SELECTED_TEMPORARY_SECONDARY_ACCESSORIES',
  SIZE_ERROR: 'SIZE_ERROR',
  GRAND_PARENT_SIZE: 'GRAND_PARENT_SIZE',
  DESELECT_SIZE: 'DESELECT_SIZE',
  GRAND_PARENT_SCREEN: 'GRAND_PARENT_SCREEN',
  GRAND_PARENT_COLOR: 'GRAND_PARENT_COLOR',
  GRAND_PARENT_FIT: 'GRAND_PARENT_FIT',
  GRAND_PARENT_QUANTITY: 'GRAND_PARENT_QUANTITY',
  CLEAR_GRAND_PARENT_DATA: 'CLEAR_GRAND_PARENT_DATA',
};

export const { breakpoints } = theme;

export const CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: true,
  autoplaySpeed: 4000,
  infinite: false,
  initialSlide: 0,
  fade: false,
  speed: 100,
  touchThreshold: 1000,
  touchMove: true,
  swipeToSlide: true,
  dots: false,
  adaptiveHeight: false,
  dotsClass: 'slick-dots',
  focusOnSelect: false,
  swipe: true,
  slidesPerRow: 3,
  centerMode: true,
  responsive: [
    {
      breakpoint: parseInt(breakpoints.mediumMax, 10),
      settings: {
        slidesPerRow: 2,
      },
    },
    {
      breakpoint: parseInt(breakpoints.medium, 10),
      settings: {
        slidesPerRow: 2,
      },
    },
  ],
};

export const actionToPerform = {
  update: 'update',
  add: 'add',
  remove: 'remove',
};

export default {
  SET_ACCESSORIES_LOADING_STATE,
  CAROUSEL_OPTIONS,
  breakpoints,
  actionToPerform,
};
